import Vue from "vue";
import VueRouter from "vue-router";
import i18n from '@/i18n'
Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        // name: 'Home',
        // meta: {
        //     title: '首页',
        // },
        redirect: "/orderList",
        component: () => import("../views/Home"),
        children: [
            // {
            //     path: '/',
            //     component: () =>
            //         import ('../components/Welcome')
            // },
            // {
            //     name:'index',
            //     path: "index",
            //     component: () =>
            //         import ('../components/index/Index')
            // },
            {
                name: "orderList",
                path: "/orderList",
                // label:'订单列表',
                meta: {
                    title: i18n.t('laund.laund1')
                },
                component: () =>
                    import("../components/orders/orderList/OrderList"),
            },
            {
                name: "createOrder",
                path: "/createOrder",
                // label:'新建订单',
                meta: {
                    title: i18n.t('router.router1'),
                },
                component: () =>
                    import("../components/orders/createOrder/CreateOrder"),
            },
            {
                name: "orderDetail",
                path: "/orderDetail",
                meta: {
                    title: i18n.t('OrderDetail.OrderDetail41'),
                },
                // label:'订单详情',
                component: () =>
                    import("../components/orders/orderList/OrderDetail"),
            },
            {
                name: "recharge",
                path: "/recharge",
                // label:'充值',
                meta: {
                    title: i18n.t('home.home3'),
                },
                component: () => import("../components/recharge/Recharge"),
            },
            {
                name: "badList",
                path: "badList",
                meta: {
                    title: i18n.t('home.home23'),
                },
                // label:'不良反馈',
                component: () => import("../components/bad/Bad"),
            },
            {
                name: "orderBill",
                path: "orderBill",
                meta: {
                    title: i18n.t('orderList.orderList21'),
                },
                // label:'账单',
                component: () =>
                    import("../components/orders/orderList/OrderBill"),
            },
            {
                name: "arrivalOrder",
                path: "arrivalOrder",
                meta: {
                    title: i18n.t('arrivalOrder.arrivalOrder1'),
                },
                // label:'到货订单',
                component: () =>
                    import("../components/orders/arrivalOrder/ArrivalOrder"),
            },
            {
                name: "buddleOrder",
                path: "buddleOrder",
                meta: {
                    title: i18n.t('BuddleOrder.BuddleOrder19'),
                },
                // label:'同捆列表',
                component: () =>
                    import("../components/orders/buddleOrder/BuddleOrder"),
            },
            {
                name: "buddleOrderDetail",
                path: "buddleOrderDetail",
                meta: {
                    title: i18n.t('BuddleOrderDetail.BuddleOrderDetail9'),
                },
                // label:'同捆列表详情',
                component: () =>
                    import(
                        "../components/orders/buddleOrder/BuddleOrderDetail"
                    ),
            },
            {
                name: "payBills",
                path: "payBills",
                meta: {
                    title: i18n.t('BuddleOrder.BuddleOrder24'),
                },
                component: () =>
                    import(
                        "../components/orders/buddleOrder/payBills"
                    ),
            },
            {
                name: "FBA",
                path: "FBA",
                meta: {
                    title: i18n.t('router.router2'),
                },
                // label:'FBA装箱单',
                component: () => import("../components/FBA/FBA"),
            },
            {
                name: "FBAContainerOrder",
                path: "FBAContainerOrder",
                meta: {
                    title: i18n.t('router.router3'),
                },
                // label:'FBA新建装箱单',
                component: () => import("../components/FBA/FBAContainerOrder"),
            },
            {
                name: "FBABill",
                path: "FBABill",
                meta: {
                    title: i18n.t('router.router4'),
                },
                // label:'FBA账单',
                component: () => import("../components/FBA/FBABill"),
            },
            {
                name: "badOrder",
                path: "badOrder",
                meta: {
                    title: i18n.t('orderList.orderList12'),
                },
                // label:'不良订单',
                component: () =>
                    import("../components/orders/badOrder/BadOrder"),
            },
            {
                name: "inStorageOrder",
                path: "inStorageOrder",
                meta: {
                    title: i18n.t('orderList.orderList10'),
                },
                // label:'仓库保管中',
                component: () =>
                    import(
                        "../components/orders/inStorageOrder/InStorageOrder"
                    ),
            },
            {
                name: "funding",
                path: "funding",
                meta: {
                    title: i18n.t('router.router5'),
                },
                // label:'资金明细',
                component: () => import("../components/funding/Funding"),
            },
            // {
            //     name: "message",
            //     path: "message",
            //     meta: {
            //         title: i18n.t('router.router6'),
            //     },
            //     // label:'消息列表',
            //     component: () => import("../components/message/Message"),
            // },
            {
                name: "message",
                path: "message",
                meta: {
                    title: i18n.t('router.router6'),
                },
                // label:'消息列表',
                component: () => import("../components/newMessage/index"),
            },
            {
                name: "recycle",
                path: "recycle",
                meta: {
                  title: i18n.t("router.router6"),
                },
                // label:'回收站',
                component: () => import("../components/newMessage/recycle"),
            },
            {
                name: "RechargeList",
                path: "RechargeList",
                meta: {
                    title: i18n.t('router.router7'),
                },
                // label:'充值记录',
                component: () => import("../components/recharge/RechargeList"),
            },
            {
                name: "personalData",
                path: "personalData",
                meta: {
                    title: i18n.t('router.router8'),
                },
                // label:'个人资料',
                component: () => import("../components/setting/PersonalData"),
            },
            {
                name: "reminderSetting",
                path: "reminderSetting",
                meta: {
                    title: i18n.t('router.router14'),
                },
                // label:'提醒设置',
                component: () => import("../components/setting/reminderSetting"),
            },
            {
                name: "accountSecurity",
                path: "accountSecurity",
                meta: {
                    title: i18n.t('router.router9'),
                },
                // label:'账号安全',
                component: () =>
                    import("../components/setting/AccountSecurity"),
            },
            {
                name: "changeEmail",
                path: "changeEmail",
                meta: {
                    title: i18n.t('changeAccount.changeAccount9'),
                },
                // label:'更换邮箱账号',
                component: () => import("../components/setting/ChangeEmail"),
            },
            {
                name: "changePassword",
                path: "changePassword",
                meta: {
                    title: i18n.t('changeAccount.changeAccount26'),
                },
                // label:'修改登录密码',

                component: () => import("../components/setting/ChangePassword"),
            },
            {
                name: "changePhone",
                path: "/changePhone",
                meta: {
                    title: i18n.t('router.router10'),
                },
                // label:'修改登录手机号',

                component: () => import("../components/setting/ChangePhone"),
            },
            {
                name: "boxList",
                path: "/boxList",
                meta: {
                    title: i18n.t('router.router11'),
                },
                // label:'装箱单详情',
                component: () => import("../components/FBA/BoxList"),
            },
            {
                name: "boxOrderList",
                path: "/boxOrderList",
                meta: {
                    title: i18n.t('router.router12'),
                },
                // label:'箱子详情',
                component: () => import("../components/FBA/BoxOrderList"),
            },
            {
                name: "address",
                path: "/address",
                meta: {
                    title: i18n.t('addr.addr1'),
                },
                // label:'地址管理',
                component: () => import("../components/address/Address"),
            },
            {
                name: "defective",
                path: "/defective",
                meta: {
                    title: i18n.t('defe.defe1'),
                },
                // label:'不良件货库',
                component: () => import("../components/defective/Defective"),
            },
            {
                name: "defectiveDetail",
                path: "/defectiveDetail",
                meta: {
                    title: i18n.t('router.router13'),
                },
                // label:'不良件货库详情',
                component: () =>
                    import("../components/defective/DefectiveDetail"),
            },
            {
                name: "laundryLabelTemplate",
                path: "/laundryLabelTemplate",
                meta: {
                    title: i18n.t('laund.laund2'),
                },
                // label:'水洗标模板管理',
                component: () => import("../components/laundryLabelTemplate/LaundryLabelTemplate"),
            },
            {
                path: "/cart",
                name: "Cart",
                meta: {
                    title: i18n.t('router.router15'),
                },
                component: () => import("../views/cart"),
            },
        ],
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../components/Login.vue"),
    },
    {
        name: "resetPassword",
        path: "/resetPassword",
        component: () => import("../components/ResetPassword.vue"),
    },
    // 物流查询
    {
        name: "logisticsInfo",
        path: "/logisticsInfo",
        component: () => import("../components/logisticsInfo.vue"),
    },
    {
        path: "/register",
        name: "register",
        component: () => import("../components/Register.vue"),
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.VUE_APP_PUBLIC_PATH,
    routes: routes,
});

//路由导航守卫
router.beforeEach((to, from, next) => {
    // console.log('router');
    // console.log(from);
    if (to.path === "/login") return next();
    if (to.path === "/resetPassword") return next();
    if (to.path === "/logisticsInfo") return next();
    const tokenStr = window.sessionStorage.getItem("token");
    // console.log(tokenStr);
    if (to.path === "/register") return next();
    if (!tokenStr) return next("/login");
    next();
});
export default router;
